import React from 'react';
import * as d3 from 'd3';

// data & content
import data18 from '../content/2018.js';
import data88 from '../content/1988.js';
import content from '../content/content.js';

let cit18 = data18.eighteen;
let cit88 = data88.eightyeight;
var prof = content.general.professions // .name .id .color

// data for generating 4 scissors
const sciGen = [
  {
    var: 'city1_88',
    clas: 'city city1 eightyeight',
    id: 'city-1-88'
  },
  {
    var: 'city2_88',
    clas: 'city city2 eightyeight',
    id: 'city-2-88'
  },
  {
    var: 'city1_18',
    clas: 'city city1 eighteen',
    id: 'city-1-18'
  },
  {
    var: 'city2_18',
    clas: 'city city2 eighteen',
    id: 'city-2-18'
  }
]

// dimensions
var winW = window.innerWidth;
var height = window.innerHeight * .81852;
var mTop = 0;
var mBot = 10;

// stripes & scale
var dHeight = 13;
var dHeight1000 = dHeight*1000
var numbers = [0, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000];
var numbersT = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, ''];
var bgCol = '#F7F7F7' // '#f8f8fa'
var stripeCol = '#fff'

// scissors
var sciW = 100;
var radius = 8;
var bipRad = radius * .75
var line = 1.2;

// page 0 || page 1
var p0top = 2000;
var p0bot = 2000;
var p0max = p0top;
var p0min = dHeight1000 - p0bot;
var p0dis = (dHeight1000 - p0top - p0bot) / 4;
var page0 = [p0top, p0top+p0dis, p0top+2*p0dis, p0top+3*p0dis, p0top+4*p0dis, p0top+1.5*p0dis];

// salary label, salary label, scale
let tagY = 1;

// prof label, salary label
let lDistS = 16;

// city label
let cityLabY = -30;

// initial gray margin
if (winW < 350) {
  mBot = 7;
} else if (winW < 500) {
  mBot = 8;
} else if (winW < 750) {
  mBot = 9;
} else if (winW < 900) {
  mBot = 10;
} else if (winW < 1500) {
  mBot = 12;
} else if (winW < 1800) {
  mBot = 14;
} else {
  mBot = 14;
}

var mHeight = height - mBot - mTop;

export default class Diagram extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.updateDiagram = this.updateDiagram.bind(this);
  }

  componentDidMount(){
    // console.log('Diagram mounted');

    // update svg on window resize
    d3.select(window).on('resize', this.updateDiagram);

    this.createDiagram()
    this.updateDiagram()
  }

  componentDidUpdate(){
    // console.log('Diagram updated');

    this.updateDiagram()
  }

  createDiagram(){

    // create svg container
    const svg = d3.select('.diagramSvg');

    // create stripes
    svg.append('g')
      .attr('class', 'stripes')
      .selectAll('rect')
      .data([1,3,5,7,9,11])
      .enter()
      .append('rect')
      .attr('fill', stripeCol)
      .attr('x', 0)
      .attr('width', winW)
      .attr('height', () => mHeight / dHeight)
      .attr('y', d => (height-mBot)-(mHeight/dHeight*d)-(mHeight/dHeight))
      .attr('class', 'opacity0-stripes')
      // .style('opacity', '100%')
      ;

    // create scale
    svg.append('g')
      .attr('class', 'scale')
      .selectAll('text')
      .data(numbers)
      .enter()
      .append('text')
      .attr('class', 'scale-number')
      .text((d, i) => numbersT[i])
      .attr('dominant-baseline', 'middle') // hanging, mathematical
      .attr('id', d => 'scale-' + d)
      .attr('x', '0')
      .style('opacity', '100%');

    svg.select('#scale-12000')
      .append('tspan')
      .attr('id', 'scale-description')
      .attr('dominant-baseline', 'middle');

    // create 4 scissor groups
    const cities = svg.selectAll('.city')
      .data(sciGen)
      .enter()
      .append('g')
      .attr('id', d => d.id);

    // create scissor line
    cities.append('polyline')
      .attr('stroke', 'black')
      .attr('fill', 'none')
      .attr('stroke-width', line)
      .attr('points', () => {
        return (
          (winW/2) + ',' + (height - mBot - (p0min * mHeight / dHeight/1000)) + ' ' +
          (winW/2) + ',' + (height - mBot - ((p0max+p0min)/2 * mHeight / dHeight/1000)) + ' ' +
          (winW/2) + ',' + (height - mBot - (p0max * mHeight / dHeight/1000))
        )
      });

    // create city label
    cities.append('text')
      .attr('class', 'city-label opacity0')
      .text('city');

    var profs = cities.selectAll('g')
      .data(prof)
      .enter()
      .append('g')
      // .attr('class', d => d.id)
      ;

    // create year label
    cities.append('text')
      .attr('class', 'year-label opacity0')
      .text('year')
      .attr('text-anchor', 'end')
      .attr('dominant-baseline', 'middle');

    // create professional circles
    profs.append('circle')
      .style('fill', (d, i) => '#' + prof[i].color)
      .attr('cx', (d,i) => Math.abs((page0[i]-p0min)*2*sciW/(p0max-p0min)-sciW)+winW/1.5-sciW/2)
      .attr('cy', (d,i) => height-mBot-(page0[i]*mHeight/13000))
      .on('click', (d, i) => this.handleClick(prof[i].id))
      .attr('r', (d, i) => {
        if (i === 5) {
          return bipRad
        } else {
          return radius
        }
      });

    // professional labels
    var profLabels = svg.append('g')
      .attr('class', 'profLabels')
      .selectAll('g')
      .data(sciGen)
      .enter()
      .append('g')
      .attr('id', d => d.id + '-labels');

    for (let i = 0; i < prof.length; i++) {

      // salary labels
      profLabels.append('text')
        .attr('id', d => d.id + '-' + prof[i].id + '-salary-label')
        .attr('class', 'prof-label opacity0')
        .attr('dominant-baseline', 'middle')
        .attr('text-anchor', 'end');

      // profession name label
      svg.select('#city-1-18-labels')
        .append('text')
        .text(() => prof[i].name )
        .attr('id', d => d.id + '-' + prof[i].id + '-label')
        .attr('x', d => winW/2)
        .attr('y', () => height-mBot-(page0[i]*mHeight/13000)+tagY)
        ;

      svg.select('#city-2-18-labels')
        .append('text')
        .text(() => prof[i].name )
        .attr('id', d => d.id + '-' + prof[i].id + '-label')
        .attr('x', d => winW/2)
        .attr('y', () => height-mBot-(page0[i]*mHeight/13000)+tagY)
        ;
    }

  }

  // U P D A T E

  updateDiagram(){

    winW = window.innerWidth;
    height = window.innerHeight * .81852;

    if (winW < 350) {
      sciW = 50;
      radius = 7;
      lDistS = 8;
      line = .7;
    } else if (winW < 500) {
      sciW = 75;
      radius = 8;
      lDistS = 8;
      line = .7;
    } else if (winW < 750) {
      sciW = 100;
      radius = 9;
      lDistS = 10;
      line = .9;
    } else if (winW < 900) {
      sciW = 100;
      radius = 10;
      lDistS = 12;
      line = 1;
    } else if (winW < 1500) {
      sciW = 125;
      radius = 12;
      lDistS = 14;
      line = 1;
    } else if (winW < 1800) {
      sciW = 150;
      radius = 14;
      lDistS = 16;
      line = 1.2;
    } else {
      sciW = 150;
      radius = 14;
      lDistS = 16;
      line = 1.2;
    }

    mBot = radius;
    mHeight = height - mBot - mTop;
    tagY = 1;

    bipRad = radius * .625;

    // basics
    const svg = d3.select('.diagramSvg');
    var p = this.props.page;
    var d = this.props.direction;
    var dir = this.props.direction;
    var a = this.props.activeProf;

    // transitions
    var t = d3.transition().duration(300);
    var t2000 = d3.transition().delay(2500).duration(500); // stripes & scale page 3
    var t1000 = d3.transition().delay(1000).duration(600);
    var t0 = d3.transition().delay(0).duration(0);

    var tScale;
    if (p === 2 && dir === 'next') {
      tScale = d3.transition().delay(2500).duration(500);
    } else if ((p === 9 && dir === 'next') /*|| (p === 8 && dir === 'prev')*/) { // uncommented for bug-fixing
      tScale = d3.transition().duration(300);
    } else {
      tScale = d3.transition().delay(0).duration(0);
    }

    // update svg
    svg.attr('width', winW)
      .attr('height', height)
      .attr('viewBox', () => "0 0 " + winW + " " + height);

    // update scale
    const scale = d3.select('.scale')
      .selectAll('text')
      .data(numbers)
      .transition(tScale)
      .attr('y', d => height - mBot - d*mHeight/dHeight/1000 + tagY)
      .attr('x', () => {
        if (p === 9) {return -500}
        else if (winW < 500) { return 16}
        else {return 32}
      });

    // update scale description
    svg.select('#scale-description')
      .text( () => {
        if ( p < 7 ) {
          return 'Monthly salary 2018 in $ 1000'
        } else {
          return 'Monthly salary 1988 and 2018 in $ 1000'
        }
      });

    // page handler scale
    if(p === 0 || p === 1) {
      scale.style('opacity', '0%')
      .attr('class', 'scale-number spacing');
    } else if(p === 9) {
      scale.style('opacity', '100%')
      .attr('class', 'scale-number spacing');
    } else {
      scale.style('opacity', '100%')
      .attr('class', 'scale-number spacing');
    }

    // update background
    d3.select('.background')
      .attr('width', winW)
      .attr('height', mHeight)
      ;

    // update stripes
    const stripes = d3.select('.stripes')
      .selectAll('rect')
      .data([1,3,5,7,9,11])
      .attr('width', winW)
      .attr('height', mHeight / dHeight)
      .attr('y', d => (height-mBot)-(mHeight/dHeight*d)-(mHeight/dHeight));

    // page handler stripes
    if(p < 2) {
      stripes.attr('class', 'opacity0-stripes center');
    } else if (p === 2 && d === 'next'){
      stripes.attr('class', 'opacity1-2000 center');
    } else if (p === 2 && d === 'prev'){
      stripes.attr('class', 'opacity1-stripes center');
    } else if (p === 9) {
      stripes.attr('class', 'opacity1-stripes nextOut');
    } else if (p === 8 && d === 'prev') {
      stripes.attr('class', 'opacity1-stripes prevIn');
    } else {
      stripes.attr('class', 'opacity1-stripes center');
    }

    // json structure of array of two selected cities
    var genArr = [
      {
        city: this.props.city1,
        data: cit88
      },
      {
        city: this.props.city2,
        data: cit88
      },
      {
        city: this.props.city1,
        data: cit18
      },
      {
        city: this.props.city2,
        data: cit18
      }
    ]

    // get indexes of all scissors
    let indexes = genArr.map(x => x.data.findIndex(city => (city.cities === x.city)))

    // get salaries of all scissors
    let data4 = indexes.map((x, i) => {
      return (
        {
          sales_assistant: genArr[i].data[x].sales_assistant,
          automobile_mechanic: genArr[i].data[x].automobile_mechanic,
          cook: genArr[i].data[x].cook,
          primary_school_teacher: genArr[i].data[x].primary_school_teacher,
          department_manager: genArr[i].data[x].department_manager,
          gdp: genArr[i].data[x].gdp
        }
      )
    });

    // array of salaries of 4 scissors
    var salaries = data4.map(x => Object.keys(x).map(function( key ) { return x[key]; }))

    // min and max of 4 scissors
    var min4 = salaries.map(x => Math.min.apply( null, x ))
    var max4 = salaries.map(x => Math.max.apply( null, x ))

    // push data to genArr
    for (let i = 0; i < genArr.length; i++){
      sciGen[i].salaries = salaries[i];
      sciGen[i].min = min4[i];
      sciGen[i].max = max4[i];
      sciGen[i].select = genArr[i].city;
    }

    // update 4 scissor lines
    svg.selectAll('polyline')
      .data(sciGen)
      .transition(p === 2 ? t1000 : t)
      .attr('points', d => {
        if (p === 0 || p === 1) {
          return (
            (winW/2) + ',' + (height - mBot - (p0min * mHeight / dHeight/1000)) + ' ' +
            (winW/2) + ',' + (height - mBot - ((p0max+p0min)/2 * mHeight / dHeight / 1000)) + ' ' +
            (winW/2) + ',' + (height - mBot - (p0max * mHeight / dHeight/1000))
          )
        } else {
          return (
            (winW/2 + sciW/2) + ',' + (height - mBot - (d.max * mHeight / dHeight/1000)) + ' ' +
            (winW/2 - sciW/2) + ',' + (height - mBot - ((d.max+d.min)/2 * mHeight / dHeight/1000)) + ' ' +
            (winW/2 + sciW/2) + ',' + (height - mBot - (d.min * mHeight / dHeight/1000))
          )
        }
      })
      .attr('stroke-width', line)
      .attr('class', (d, i) => p === 1 && i === 2 ? 'polyline-1' : '')
      ;

    // update city label
    var cityLabel = svg.selectAll('text.city-label')
      .data(sciGen)
      .transition(p === 2 ? t1000 : t0)
      .attr('class', (d, i) => {
        if (i > 1 && (p === 2 || p === 3 || p === 5 || p=== 7) ) {
          return 'city-label opacity1'
        } else {
          return 'city-label opacity0'
        }
      })
      .attr('x', () => (p === 0) ? winW/1.5 : winW/2)
      .attr('y', d => {
        if (p <= 1) {
          return height-mBot-(page0[4]*mHeight/13000) + cityLabY
        } else {
          return height - mBot - (d.max * mHeight / dHeight/1000) + cityLabY
        }
      })
      .text(d => d.select)
      .attr('text-anchor', 'middle')
      ;

    // make city labels really invisible after transition.opacity.0
    if (p === 2 || p === 3 || p === 5 || p === 7) {
      cityLabel.style('visibility', 'visible')
    } else {
      cityLabel.transition()
        .duration(0)
        .delay(300)
        .style('visibility', 'hidden');
    }

    // update year labels
    var yearLabel = svg.selectAll('text.year-label')
      .data(sciGen)
      .transition(t)
      .attr('class', (d,i)=>{
        if ((p === 7 || p === 8) && (d.id === 'city-1-88' || d.id === 'city-1-18')) {
          return 'year-label opacity1 spacing'
        } else {
          return 'year-label opacity0 spacing'
        }
      })
      .attr('x', () => winW/2 - sciW/2 - 1.75*lDistS)
      .attr('y', d => {
        return height - mBot - ((d.max+d.min)/2 * mHeight / dHeight/1000)
      })
      .text(d => {
        if (d.id === 'city-1-88') {
          return '1988'
        } else if (d.id === 'city-1-18') {
          return '2018'
        } else {
          return ''
        }
      })
      ;

    // loop through 4 scissors
    // update circles
    for (let i = 0; i < sciGen.length; i++) {
      var id = '#' + sciGen[i].id
      var min = Math.min.apply( null, sciGen[i].salaries );
      var max = Math.max.apply( null, sciGen[i].salaries );
      svg.select(id)
        .selectAll('circle')
        .data(sciGen[i].salaries)
        .transition(p === 2 ? t1000 : t)
        .attr('cx', (d,k) => {
          if (k === 5 && p <= 2 && dir === 'next') {
            return winW
          } else if ((p === 0 || p === 1) && winW > 750) {
            return winW/2
          } else if ((p === 0 || p === 1) && winW <= 750) {
            return winW*.62
          } else {
            return Math.abs((d-min)*2*sciW/(max-min)-sciW)+winW/2-sciW/2
          }
        })
        .attr('cy', (d,k) => {
          if (p === 0 || p === 1) {
            return height-mBot-(page0[k]*mHeight/13000)
          } else {
            return height-mBot-(d*mHeight/13000)
          }
        })
        .attr('r', (d, i) => {
          if (i === 5) {
            return bipRad
          } else {
            return radius
          }
        })
        // .attr('class', (d, j) => { // was part of trying pulsating one circle for UX
        //   return sciGen[i].clas + ' ' + prof[j].id
        // })
        ;

      // manage dot visibility on g-element level because of firefox animation performance issue
      svg.select(id)
        .selectAll('g')
        .data(sciGen[i].salaries)
        .transition(t)
        .attr('class', (d, i) => {
          if (i === 5 && (p === 0 || p === 1 || p === 2)) {
            return 'gdp hide'
          } else if (p === 1 && dir === 'next') {
            return 'dot-g ' + prof[i].id + '-dot-' + p
          } else {
            return 'dot-g'
          }
        });

      // loop through 6 salaries
      let city = sciGen[i].id
      for (let j = 0; j < prof.length; j++) {

        // update salary label
        let label = '#' + sciGen[i].id + '-' + prof[j].id + '-salary-label'
        var salary = sciGen[i].salaries[j]

        var salLab = svg.select(label)
          .text(() => '$ ' + salary)
          .transition(p === 2 ? t1000 : t)
          .attr('x', () => {
            if (j === 5 && p <= 2 && dir === 'next') {
              return winW
            } else if ((p === 0 || p === 1) && winW > 750) {
              return winW / 2 + radius + lDistS
            } else if ((p === 0 || p === 1) && winW <= 750) {
              return winW * .62 + radius + lDistS
            } else {
              return Math.abs((salary-min)*2*sciW/(max-min)-sciW)+winW/2-sciW/2+ radius + lDistS
            }
          })
          .attr('y', () => {
            if (p === 0 || p === 1) {
              return height-mBot-(page0[j]*mHeight/13000)+tagY
            } else {
              return height-mBot-(salary*mHeight/13000)+tagY
            }
          })
          .attr('class', () => {
            if (a === prof[j].id) {
              return 'salary-label opacity1 spacing'
            } else if (((p === 2) && (j !== 5)) || (p === 3)) {
              return 'salary-label opacity1 spacing'
            } else if (a === 'all') {
              return 'salary-label opacity0 spacing'
            } else {
              return 'salary-label opacity0 spacing'
            }
          })
          .attr('text-anchor', 'start');;

        // make salary labels really invisible after transition.opacity.0
        if (p === 1 || p===2 || p===3 || a === prof[j].id) {
          salLab.style('visibility', 'visible');
        } else {
          salLab.transition()
            .duration(0)
            .delay(300)
            .style('visibility', 'hidden');
        }

        // update profession name label
        if (p === 0) { salary = page0[j]}
        let pLabel = '#' + sciGen[i].id + '-' + prof[j].id + '-label'
        var pnLab = svg.select(pLabel)
          .transition(p === 2 ? t1000 : t)
          .attr('x', () => {
            if (j === 5 && p <= 2 && dir === 'next') {
              return winW
            } else if ((p === 0 || p === 1) && winW > 750) {
              return winW / 2 - radius - lDistS
            } else if ((p === 0 || p === 1) && winW <= 750) {
              return winW * .62 - radius - lDistS
            } else {
              return Math.abs((salary-min)*2*sciW/(max-min)-sciW)+winW/2-sciW/2 - radius - lDistS
            }
          })
          .attr('y', () => {
            if (p === 0 || p === 1) {
              return height-mBot-(page0[j]*mHeight/13000)
            } else {
              return height-mBot-(salary*mHeight/13000)+tagY
            }
          })
          .attr('class', () => {
            if (p === 0) {
              return 'prof-label prof-0'
            } else if (p === 1 && d === 'next') {
              return 'prof-label prof-0 ' + prof[j].id + '-label-' + p + ' page-' + p
            } else if ((p === 1 || p === 2 || p === 3) && (j !== 5)) {
              return 'prof-label page-' + p +  ' spacing'
            } else if ((p === 3) && (j === 5)) {
              return 'prof-label opacity1 page-' + p +  ' spacing'
            } else if ((p > 4) && (a === prof[j].id) && (winW >= 750) && (i === 3)) {
              return 'prof-label opacity1 page-' + p +  ' spacing'
            } else if ((p === 4) && (a === prof[j].id) && (i === 2)) {
              return 'prof-label opacity1 page-' + p +  ' spacing'
            } else if ((p >= 5) && (a === prof[j].id) && (winW < 750) && (i === 3)) {
              return 'prof-label opacity1 page-' + p +  ' spacing'
            } else {
              return 'prof-label opacity0 page-' + p +  ' spacing'
            }
          })
          .attr('dominant-baseline', 'middle')
          .attr('text-anchor', 'end');

        // make professional name labels really invisible after transition.opacity.0
        if ( p <= 3 || a === prof[j].id) {
          pnLab.style ( 'visibility', 'visible' ) ;
        } else {
          pnLab.transition ( )
            .duration ( 0 )
            .delay ( 300 )
            .style ( 'visibility', 'hidden' ) ;
        }
      }

    }

    // // try to add pulsating to one circle
    // var city1pst = svg.selectAll('.city1.eighteen.primaryschoolteacher')
    // .each(pulse);
    //
    // function pulse() {
    //   var circle = svg.select('.city1.eighteen.primaryschoolteacher');
    //   (function repeat() {
    //     console.log('each');
    //     circle = circle
    //     // .append('text')
    //      // .transition()
    //     	// .duration(2000)
    //     	// .attr("r", 10)
    //     	// .transition()
    //     	// .duration(2000)
    //     	// .attr("r", 200)
    //     	// .ease('sine')
    //     	.each("end", repeat);
    //   })();
    // };

    // handle scissor classes depending on page navigation direction
    // 1: 88 left
    // 2: 88 right
    // 3: 18 left
    // 4: 18 right
    var nextClas = [
    // class in case of reaching it by clicking "next"
    //  1         2          3           4          5          6            7        8             9                     10
      ['hide',   'hide',    'hide',     'hide',    'hide',    'hide',      'hide',  'left app',   'left eightyeight',   'nextLeftOut eightyeight'],
      ['hide',   'hide',    'hide',     'hide',    'hide',    'hide',      'hide',  'right app',  'right eightyeight',  'nextRightOut eightyeight'],
      ['hide',   'center',  'center',   'center',  'center',  'nextLeft',  'left',  'left',       'left',               'nextLeftOut'],
      ['hide',   'hide',    'hide',     'hide',    'hide',    'nextRight', 'right', 'right',      'right',              'nextRightOut']
    ]
    var prevClas = [
    // class in case of reaching it by clicking "previous"
    //  1         2          3              4          5              6        7              8                    9                         10
      ['hide',   'hide',    'hide',        'hide',    'hide',        'hide',  'left disapp', 'left eightyeight',  'prevLeft eightyeight',   'hide'],
      ['hide',   'hide',    'hide',        'hide',    'hide',        'hide',  'right disapp','right eightyeight', 'prevRight eightyeight',  'hide'],
      ['hide',   'center',  'center',      'center',  'prevCenter',  'left',  'left',        'left',              'prevLeft',               'hide'],
      ['hide',   'hide',    'hide',        'hide',    'prevRightOut','right', 'right',       'right',             'prevRight',              'hide']
    ]
    for (let i = 0; i < sciGen.length; i++) {
      id = '#' + sciGen[i].id
      svg.select(id)
        .attr('class', () => {
          if (d === 'next') {
            return sciGen[i].clas + ' ' + nextClas[i][p]
          } else {
            return sciGen[i].clas + ' ' + prevClas[i][p]
          }
        });

      let idl = '#' + sciGen[i].id + '-labels';
      svg.select(idl)
        .attr('class', () => {
          if (d === 'next') {
            return sciGen[i].clas.substring(0,10) + ' ' + nextClas[i][p]
          } else {
            return sciGen[i].clas.substring(0,10) + ' ' + prevClas[i][p]
          }
        });

    }
  }

  handleClick(prof){
    this.props.onChange({s: 'activeProf', v: prof});
  }

  render() {
    // console.log('Diagram rendered');
    return (
      <div className="Diagram">
        <svg className="diagramSvg">
          <rect className="background" fill={bgCol}></rect>
        </svg>
      </div>
    )
  }
}
